import { IUserActionTypes } from "../../action-types/user/IUserActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IUserReducer } from "../../reducer-model/user/IUserReducer";
const iniState: IUserReducer = {
    selectedIds: [],
    status: eReducerStatusBase.is_not_initialization,
    users: [],
    userEditing: undefined
}
export const userReducer = (state: IUserReducer = iniState, action: IUserActionTypes): IUserReducer => {
    switch (action.type) {
        case "USER_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "USER_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                users: action.payload
            }
        case "USER_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                users: []
            }

        case "USER_SHOW_EDIT_MODAL":
            return {
                ...state,
                is_show_edit_modal: true,
                userEditing: action.payload
            }
        case "USER_CLOSE_EDIT_MODAL":
            return {
                ...state,
                is_show_edit_modal: false,
                userEditing: undefined
            }
        case "USER_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "USER_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                is_show_edit_modal: false
            }
        case "USER_DELETE_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "USER_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "USER_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "USER_SAVE_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}